import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const WebsiteContext = createContext(null);
export const useWebsite = () => useContext(WebsiteContext);

export function WebsiteProvider({ children, previewContent, initialContent }) {
  const [content, setContent] = useState(previewContent || initialContent || (typeof window !== "undefined" && window.__BG_CONTENT__) || null);
  const [error, setError] = useState("");
  const load = () => {
    setError("");
    api.get("/website").then(r => setContent(r.data.content)).catch(() => setError("We couldn't load the website content. Please retry or email bookghost.support@gmail.com."));
  };
  useEffect(() => { if (!previewContent) load(); }, [previewContent]);
  if (error) return <div className="section container-narrow" role="alert" data-testid="website-load-error"><p>{error}</p><button className="studio-button mt-4" data-testid="website-retry" onClick={load}>Try again</button></div>;
  if (!content) return <div className="section container-narrow" role="status" data-testid="website-loading">Preparing your reading space…</div>;
  return <WebsiteContext.Provider value={{ content: previewContent || content, preview: !!previewContent }}>{children}</WebsiteContext.Provider>;
}

const SITE_URL = "https://bookghostpublishing.com";

export function PageMetadata({ title, description }) {
  if (typeof document === "undefined") { globalThis.__BG_META__ = { title, description }; }
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
    if (window.location.pathname.startsWith("/admin")) { return; }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = SITE_URL + (window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/$/, ""));
  }, [title, description]);
  return null;
}

export const rupees = n => `₹${Number(n).toLocaleString("en-IN")}`;
export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(d => `${d.loc?.slice(1).join(" → ")}: ${d.msg}`).join("; ");
  return "Could not save. Please try again.";
}
